import useMutationApi from 'src/api/useMutationApi';

interface Body {
  email: string;
  password: string;
}

const useEmailPasswordLogIn = (onSuccess?: () => void) => {
  return useMutationApi<Body>({
    endpoint: 'auth/login',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useEmailPasswordLogIn;
